import React from "react";
import Header from "../header/Header";
import PricingComp from "../components/pricing/PricingComp";
import PricingMore from "../../components/pricing/PricingMore";

const Pricing: React.FC = () => {
  return (
    <section>
      <Header />
      <PricingComp />
      <PricingMore />
    </section>
  );
};

export default Pricing;
